import script from "./GameReward.vue?vue&type=script&setup=true&lang=js"
export * from "./GameReward.vue?vue&type=script&setup=true&lang=js"

import "./GameReward.vue?vue&type=style&index=0&id=2ff66958&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ff66958"]])

export default __exports__